import '../App.css';
import React, { Component, useEffect, useState } from 'react'
import { withAuthenticator } from '@aws-amplify/ui-react'
import { BrowserRouter, Route, Switch, withRouter} from 'react-router-dom';
import Amplify, {Auth, API, graphqlOperation, Storage } from 'aws-amplify'
import awsExports from "../aws-exports";
import File from './File.js'

Amplify.configure(awsExports);
Storage.configure(awsExports);

class AddSlidePopup extends React.Component {
    
    constructor(){
        super();
        this.state = {
            files: [],
            oldFiles: [],
            urls:[],
            currentFiles: [],
            openFiles: false,
            addedFiles: [],
            addedFilesIds: [],
            isUploading: false,
            LoadingText: "Loading ..."
        };
        this.handleChange = this.handleChange.bind(this);
    }

    
    processStorage = (results) =>{
        console.log(results);
        const CopyArray = [];//https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/
        for(var i = 0; i < results.length; i++){
        CopyArray.push({url: ("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + results[i].key), id: results[i].eTag});
        }
        this.setState({currentFiles: CopyArray, openFiles: true});
    }
    
    fetchStorage= async(e) =>{
        Storage.list(Auth.user.username + '/') // for listing ALL files without prefix, pass '' instead
        .then(result => this.processStorage(result))
        .catch(err => console.log(err));

    }


    handleClick = () => {
        this.props.toggle();
    };

    SearchForFile(newFiles, oldFiles, index) {
        var oldFileName = "";
        console.log(oldFiles.length)
        for(var  i = 0; i < oldFiles.length; i++){
            oldFileName = oldFiles[i].file.key.substring(oldFiles[i].file.key.indexOf('/') + 1,oldFiles[i].file.key.length);
            if(newFiles[index].name === oldFileName){
                alert(newFiles[index].name + " - There is already a file with that name\nERROR - Make sure file names are unique");
                return true;
            }
            console.log("Iterate");
        }
        if(index + 1 < newFiles.length){
            return this.SearchForFile(newFiles, oldFiles, index + 1);
        }
        return false;
        
    }

    async handleChange(e){
    
        e.preventDefault();
        this.setState({isUploading: true, LoadingText: "Checking For Spaces"});
        for(var i = 0; i < e.target.files.length; i++){
            if(e.target.files[i].name.includes(" ")){
                
                this.setState({isUploading: false});
              alert(e.target.files[i].name + " - Has a space in it\nERROR - Make sure file names don't contain any spaces");
              e.target.value = null;
              return;
            }
        }

        const r = [];
        this.setState({LoadingText: "Checking Server For Duplicates"});
        
        await Storage.list(Auth.user.username + '/') // for listing ALL files without prefix, pass '' instead
        .then(result => {
            const CopyArray = [];//https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/
            for(var i = 0; i < result.length; i++){
                CopyArray.push({file: result[i]});
            }
            this.setState({oldFiles: CopyArray});
        })
        .catch(err => console.log(err));

        const duplicates = await this.SearchForFile(e.target.files, this.state.oldFiles, 0)
        if(duplicates){
            e.target.value = null;
            this.setState({isUploading: false});
            return;
        }
        
        this.setState({LoadingText: "Uploading Document "});
        const CopyArray = [];
        for(var i = 0; i < e.target.files.length; i++){
            //console.log(e.target.files[i].name)
            if(e.target.files[i].name.substring(e.target.files[i].name.length - 3, e.target.files[i].name.length) == "png"){
                    
                const result = await Storage.put(Auth.user.username + "/" +  e.target.files[i].name, e.target.files[i], {
                    level: 'public',
                    contentType: 'image/png',
                    progressCallback: progress =>{
                        
                        //console.log("Uploading Document " + e.target.files[i].name + " \nProgress:" + progress.loaded/progress.total + this.state.LoadingText );
                        this.setState({LoadingText: "Uploading Document " + e.target.files[i].name + " Progress: " +  ((progress.loaded/progress.total)*100.0).toFixed(1) + "%"});
                    }
                })
            }
            else{
                const result = await Storage.put(Auth.user.username + "/" +  e.target.files[i].name, e.target.files[i], {
                    level: 'public',
                    contentType: 'video/mp4',
                    progressCallback: progress => {
                        //console.log("Uploading Document " + e.target.files[i].name + " \nProgress:" + progress.loaded/progress.total + this.props);
                        this.setState({LoadingText: "Uploading Document " + e.target.files[i].name + " [" + ((progress.loaded/progress.total)*100.0).toFixed(1) + "%]"});
                    }
                })
            }
            CopyArray.push("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + Auth.user.username + "/" + e.target.files[i].name);
        }
        this.setState({urls: CopyArray});
        this.props.toggle();
        
        this.setState({isUploading: false});
        alert("Sides Successfully Uploaded");
        
        this.props.addSlides(this.state.urls);
    }


    addFilesToSlideshow = () =>{
        this.setState({urls: this.state.addedFiles});
        this.setState({openFiles: false, addedFiles: [], addedFilesIds: []});
        
        console.log(this.state.urls);
        this.props.toggle();
        alert("Sides Successfully added");
        
        this.props.addSlides(this.state.addedFiles);
    }

    removeFilesFromStorage= async(e) =>{
        var r = window.confirm("Are you sure you want to DELETE these files from storage?");
        if (r == true) {
            
            this.setState({isUploading: true, LoadingText: "Deleting Files"});
            for(var i = 0; i < this.state.addedFiles.length; i++){
                await Storage.remove(this.state.addedFiles[i].substring(this.state.addedFiles[i].indexOf(Auth.user.username+ "/"), this.state.addedFiles[i].length), {})
                .then (result => console.log("DELETED"))
                .catch(err => console.log(err));
                
            }
            this.setState({openFiles: false, addedFiles: [], addedFilesIds: []});
            
            this.props.toggle();
            alert("Files Successfully Deleted From Storage");
            
            this.setState({isUploading: false});
        }else{

        }
    }
    
    addRemoveFileToList = (isAdded, fileUrl, fileId) =>{
        if(isAdded){
            const TempArray = Object.assign([], this.state.addedFiles);
            TempArray.push(fileUrl);
            this.setState({addedFiles: TempArray});

            
            const TempArrayTwo = Object.assign([], this.state.addedFilesIds);
            TempArrayTwo.push(fileId);
            this.setState({addedFilesIds: TempArrayTwo});
        }
        else{
            const TempArray = Object.assign([], this.state.addedFilesIds);
            TempArray.splice(this.state.addedFilesIds.indexOf(fileUrl),1);
            this.setState({addedFilesIds: TempArray});

            
            const TempArrayTwo = Object.assign([], this.state.addedFiles);
            TempArrayTwo.splice(this.state.addedFiles.indexOf(fileId),1);
            this.setState({addedFiles: TempArrayTwo});
        }
    }

    render() {
        return (
            <div className="modal">
            <div className="modal_LoadingOverlay" style={{display: this.state.isUploading ? 'flex' : 'none' }}><div class="loader"></div>{this.state.LoadingText}</div>
                <div className="modal_content">
                    <div className="modal_header">
                        <button  style={{display: this.state.openFiles ? 'flex' : 'none' }} onClick={this.addFilesToSlideshow}>Add ({this.state.addedFiles.length}) File(s) to Slideshow</button>
                        <button  style={{display: this.state.openFiles ? 'flex' : 'none' }} onClick={this.removeFilesFromStorage}>Delete ({this.state.addedFiles.length}) File(s) From Storage</button>
                        <div className="close" onClick={this.handleClick}>&times;</div>
                    </div>
                    <div className="modal_body" style={{display: this.state.openFiles ? 'none' : 'block' }}>
                        <div className="modal_Button">
                            <label class="custom-file-upload">
                                <input id="file" type="file" accept="image/png, video/mp4" onChange={this.handleChange} multiple/>
                                    
                            </label>
                        </div>
                        <div className="modal_Button">
                            <button id="FileStorageBtn" onClick={this.fetchStorage}></button>
                        </div>
                    </div>
                    <div className="modal_CurrentFiles" style={{display: this.state.openFiles ? 'flex' : 'none' }}>
                        <ul id="RetrievedFileList">
                            {
                                this.state.currentFiles.map((currentFiles, index )=>{
                                    return(
                                        <li id="FileListElement">
                                        { 
                                        React.createElement(File, {addRemove: this.addRemoveFileToList, key: currentFiles.id, id: currentFiles.id, url: currentFiles.url, type: currentFiles.url.substring(currentFiles.url.length-3,currentFiles.url.length)})
                                        }
                                        </li>
                                    )
                                })
                                
                            }
                            
                            <li style={{display: this.state.currentFiles.length === 0 ? "block" : "none"}}> EMPTY</li>
                        </ul>
                        
                    </div>
                </div>
            </div>
        );
    }

}


export default withRouter(AddSlidePopup);

/**
 * uploadImage = e =>{
        for(var i = 0; i < this.state.file.length; i++){
          if(this.state.file[i].name.includes(" ")){
            console.log("ERROR - Make sure image name doesn't have any spaces");
            return;
          }
        }
    
    
        const TempArray = Object.assign([], this.state.filePaths);
        for(var i = 0; i < this.state.file.length; i++){
          TempArray.push(this.state.title + "_" + this.state.file[i].name);
        }
    
        for(var i = 0; i < this.state.file.length; i++){
          Storage.put(Auth.user.username + "/" + TempArray[i], this.state.file[i], {
            level: 'public',
            contentType: 'image/png'
          })
          .then (result => console.log(result))
          .catch(err => console.log(err));
        }
    
        const CopyArray = Object.assign([], this.state.filePaths);
        const CopyArrayTwo = Object.assign([], this.state.fileNames);
    
        var titleTemp = this.state.title;
        while(titleTemp.search(" ") > 1){
          var index = titleTemp.indexOf(" ");
          
          //console.log(titleTemp.substr(0, index) + "+" + titleTemp.substr(index, titleTemp.length));
          titleTemp = titleTemp.substr(0, index) + "+" + titleTemp.substr(index+1, titleTemp.length);
        }
        for(var i = 0; i < this.state.file.length; i++){
          CopyArray.push("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + Auth.user.username + "/" + titleTemp + "_" + this.state.file[i].name);
          
          CopyArrayTwo.push(this.state.file[i].name);
        }
        this.setState({
          file: [],
          filePaths: CopyArray,
          fileNames: CopyArrayTwo
        });
    }
 */